export default __webpack_public_path__ + "static/media/55_1_0.09e4e0ba.png";